export default {
  formatDate (date, setLastDay) {
    const now = new Date()
    const d = new Date(date)
    const threeYearsAgo = new Date(now.setMonth(now.getMonth() - 36))
    let month = '' + (d.getMonth() + 1)
    let day = '01'
    const year = d.getFullYear()
    if (month.length < 2) month = '0' + month
    if (setLastDay) {
      const lastDay = new Date(year, month, 0)
      day = lastDay.getDate()
    }
    if (d.getTime() <= threeYearsAgo.getTime()) {
      day = threeYearsAgo.getDate()
    }
    return [year, month, day].join('-')
  },
}
